export default __webpack_public_path__ + "static/media/ladies-tour2.9f81197c.jpg";